import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetaDataDropdowns } from './createHearingMetaData/MetaDataDropdowns';
import { MetaDataEsdhTitle } from './createHearingMetaData/MetaDataEsdhTitle';
import { MetaDataDatePickers } from './createHearingMetaData/MetaDataDatePickers';
import { MetaDataContactInformation } from './createHearingMetaData/MetaDataContactInformation';
import { MetaDataButtons } from './createHearingMetaData/MetaDataButtons';
import { StakeHoldersInfoBox } from './createHearingMetaData/StakeHoldersInfoBox';
import { MetaDataSwitches } from './createHearingMetaData/MetaDataSwitches';

const CreateHearingMetaData = ({
  subjectAreas,
  cityAreas,
  hearingTypes,
  kleHierarchies,
  updateHearingModelAttribute,
  updateHearingModelRelationship,
  hearingModel,
  updateHearingMetaData,
  isUpdatingHearing,
  hearingModelInCreatedStatus,
  esdhTemplates,
  selectedEsdhTemplateId,
  setSelectedEsdhTemplateId,
  showErrors,
  currentHearingStatus,
}) => {
  const { t: translator } = useTranslation();

  return (
    <div className="create-hearing-write">
      <div className="create-form-hearing-simple" id="create-hearing-part-1">
        <div className="create-hearing-sub-header">
          <h3>{translator('pages.createHearing.headerMaster')}</h3>
        </div>
        <MetaDataDropdowns
          subjectAreas={subjectAreas}
          cityAreas={cityAreas}
          hearingTypes={hearingTypes}
          kleHierarchies={kleHierarchies}
          updateHearingModelAttribute={updateHearingModelAttribute}
          updateHearingModelRelationship={updateHearingModelRelationship}
          hearingModel={hearingModel}
          hearingModelInCreatedStatus={hearingModelInCreatedStatus}
          setSelectedEsdhTemplateId={setSelectedEsdhTemplateId}
          showErrors={showErrors}
        />
        <MetaDataEsdhTitle
          updateHearingModelAttribute={updateHearingModelAttribute}
          hearingModel={hearingModel}
          hearingModelInCreatedStatus={hearingModelInCreatedStatus}
          esdhTemplates={esdhTemplates}
          selectedEsdhTemplateId={selectedEsdhTemplateId}
          setSelectedEsdhTemplateId={setSelectedEsdhTemplateId}
          showErrors={showErrors}
        />
        <MetaDataDatePickers
          updateHearingModelAttribute={updateHearingModelAttribute}
          hearingModel={hearingModel}
          showErrors={showErrors}
        />
        <MetaDataSwitches
          updateHearingModelAttribute={updateHearingModelAttribute}
          hearingModel={hearingModel}
          hearingModelIsCreatedStatus={hearingModelInCreatedStatus}
        />
        <MetaDataContactInformation
          updateHearingModelAttribute={updateHearingModelAttribute}
          hearingModel={hearingModel}
          showErrors={showErrors}
        />
        <MetaDataButtons
          updateHearingMetaData={updateHearingMetaData}
          isUpdatingHearing={isUpdatingHearing}
        />
      </div>
      <div>
        <StakeHoldersInfoBox
          updateHearingModelAttribute={updateHearingModelAttribute}
          hearingModel={hearingModel}
          currentHearingStatus={currentHearingStatus}
        />
      </div>
    </div>
  );
};

export { CreateHearingMetaData };
